import { Injectable } from '@angular/core';
import { AdminGroupAssignmentsService } from 'src/app/admin/management/admin-group-assignments.service';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { PointStoreProductAssignService } from './point-store-product-assign.service';
import { PointStoreProductEditService } from './point-store-product-edit.service';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductAssignmentService {

  pointStoreProductAssignmentFactory = {};
  agaf = null;
  pspef = null;
  newAssignment: any = null;

  constructor(
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreProductAssignService: PointStoreProductAssignService,
    private adminGroupAssignmentsService: AdminGroupAssignmentsService,
    private cvApiService: CVApiService
  ) {
    this.agaf = this.adminGroupAssignmentsService.data;
    this.pspef = this.pointStoreProductEditService.pointStoreProductEditObj;
  }

  addAssignment(EmpGroupID, EmpGroupLevel) {
    if (EmpGroupID != 0) {
      if (this.doesAssignmentNotExist(EmpGroupID, EmpGroupLevel)) {
        //pointStoreProductAssignmentFactory.pspef.modifiedPointStoreProduct.AssignedGroups = false;
        this.newAssignment = this.pointStoreProductAssignService.getNewAssignment();

        this.newAssignment.EmpGroupID = EmpGroupID;
        this.newAssignment.EmpGroupLevel = EmpGroupLevel;

        this.adminGroupAssignmentsService.getGroupEmpNameForAssignments(EmpGroupID, EmpGroupLevel);
        this.newAssignment.Name = this.agaf.selectedGroupAssignment.GroupName;
        this.newAssignment.GroupSubNames = this.agaf.selectedGroupAssignment.GroupSubNames;
        this.newAssignment.GroupTypeName = this.agaf.selectedGroupAssignment.GroupTypeName;

        this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.push(this.newAssignment);
      }
    }
  }
  addAssignmentLazy(EmpGroupID, EmpGroupLevel) {
    if (this.doesAssignmentNotExist(EmpGroupID, EmpGroupLevel)) {
      this.newAssignment = this.pointStoreProductAssignService.getNewAssignment();

      this.webcall_GetAssignmentData(EmpGroupID, EmpGroupLevel).then(
        (result) => {
          if (result != null) {
            var empGroupName = result.Item1;
            var empGroupTypeName = result.Item2;
            var groupPath = result.Item3;

            this.newAssignment.EmpGroupID = EmpGroupID;
            this.newAssignment.EmpGroupLevel = EmpGroupLevel;
            this.newAssignment.Name = empGroupName;
            this.newAssignment.GroupSubNames = groupPath;
            this.newAssignment.GroupTypeName = empGroupTypeName;

            this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.push(this.newAssignment);
          }
        }
      );
    }
  }

  async webcall_GetAssignmentData(EmpGroupID, EmpGroupLevel) {
    try {
      const url = "/api/v1/marketplace/assignments/" + EmpGroupID + EmpGroupLevel + "/";
      let response: any = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        return response.data;
      }
      else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error Loading Point Store Products: " + error.message);
    }
  }

  removeAssignment(item) {
    if (this.pspef.modifiedPointStoreProduct.PointStoreProductID == 0) {
      this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.splice(this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.indexOf(item), 1);
    } else {
      for (let i = 0; i < this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.length; i++) {
        if (
          this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupLevel == item.EmpGroupLevel &&
          this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupID == item.EmpGroupID
        ) {
          this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.splice(i, 1);
        }
      }
    }
  }

  doesAssignmentNotExist(EmpGroupID, EmpGroupLevel) {
    let match_does_not_exist = true;
    if (this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.length != 0) {
      let newObj = this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.filter((assignment) => {
        let bool = false;

        if (assignment.EmpGroupID == EmpGroupID && assignment.EmpGroupLevel == EmpGroupLevel) {
          bool = true;
        }
        return bool;
      });

      if (newObj.length != 0) {
        match_does_not_exist = false;
      }
    }
    return match_does_not_exist;
  }

  /*Add or Remove Group to aspx control*/
  glAddGroups() {
    /*Remove Class Hidden Group to aspx control*/
    this.glAddGroups();
  }
  glRemoveGroups() {
    /*Add Class Hidden Group to aspx control*/
    this.glRemoveGroups();
  };

  addRemoveAssignmentGroup() {
    this.glAddGroups();

    for (let i = 0; i < this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.length; i++) {
      if (this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupID == 0 && this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupLevel == 5) {
        this.glRemoveGroups();
        break;
      }

      /*Remove Group to aspx control*/
      this.glRemoveGroup(this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupID, this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments[i].EmpGroupLevel);
    }
  }

  //Pages that use this control will need to call 'glRemoveGroup' function so that we can handle that here
  //The call should pass the gID and gLvl
  glRemoveGroup(gid, glvl) { /***this was not here */
    $(".gi[gid='" + gid + "'][lvl='" + glvl + "']").addClass("hidden");
  }

  addRemoveAllAssignmentGroup() {
    this.pointStoreProductEditService.setUpgLoad(true);
    this.glAddGroups();

    let newObj = this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.filter((assignment) => {

      if (assignment.PointStoreProductID == 0) {
        return false;
      }
      assignment.isRemoved = true;
      return true;
    });
    this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments = angular.copy(newObj);

    if (this.pspef.modifiedPointStoreProduct.AssignedGroups) {
      this.newAssignment = this.pointStoreProductAssignService.getNewAssignment();
      this.newAssignment.EmpGroupID = 0;
      this.newAssignment.EmpGroupLevel = 5;
      this.newAssignment.Name = 'All Groups Assigned';
      this.pspef.modifiedPointStoreProduct.PointStoreProductAssignments.push(this.newAssignment);

      this.glRemoveGroups();
    }
    this.pointStoreProductEditService.setUpgLoad(false);
  }

  setGroupEmpNameForAssignments() {
    if (this.pspef.collection.isAssignmentLoaded == false) {
      for (let i = 0; i < this.pspef.collection.originalData.length; i++) {
        for (let j = 0; j < this.pspef.collection.originalData[i].PointStoreProductAssignments.length; j++) {
          this.adminGroupAssignmentsService.getGroupEmpNameForAssignments(this.pspef.collection.originalData[i].PointStoreProductAssignments[j].EmpGroupID, this.pspef.collection.originalData[i].PointStoreProductAssignments[j].EmpGroupLevel);

          this.pspef.collection.originalData[i].PointStoreProductAssignments[j].Name = this.agaf.selectedGroupAssignment.GroupName;
          this.pspef.collection.originalData[i].PointStoreProductAssignments[j].GroupSubNames = this.agaf.selectedGroupAssignment.GroupSubNames;
          this.pspef.collection.originalData[i].PointStoreProductAssignments[j].GroupTypeName = this.agaf.selectedGroupAssignment.GroupTypeName;

          if (this.pspef.collection.originalData[i].PointStoreProductAssignments[j].EmpGroupID == 0 && this.pspef.collection.originalData[i].PointStoreProductAssignments[j].EmpGroupLevel == 5) {
            this.pspef.modifiedPointStoreProduct.AssignedGroups = true;
          }
        }
      }
      this.pspef.collection.isAssignmentLoaded = true;
    }
  }
}
